export default "__VITE_ASSET__DWglsJ8a__"